import api from './api';

export interface StatusProjeto {
  id: string;
  nome: string;
  codigo: string;
}

export const getAllStatusProjeto = () => api.get<StatusProjeto[]>('status/projetos');
export const getStatusProjetoById = (id: string) => api.get(`status/projetos/${id}`);
export const getAllOptions = () =>
  getAllStatusProjeto().then(statusUsuario =>
    (statusUsuario || []).map(t => ({ text: t.nome, value: t.id.toString() })),
  );
